import React, {Fragment} from "react";
import { Button, Intent } from "@blueprintjs/core";

import SequenceInterludePagination from "../SequenceInterludePagination";
import { translate } from "utlis/translations/i18n";

class PlayerInterlude extends React.Component {
  render() {
    const {
      session,
      current,
      interludes = [],
      instance,
      onNextInterlude,
      onPrevInterlude,
      onFinishInterlude
    } = this.props;
    const { metadata } = session;
    const { type } = metadata;

    if (current >= interludes.length || current < 0)
      return (
        <p>{translate('player.interludeCouldNotBeDisplayed')}</p>
      );
    if (type === "PILOTED")
      return (
        <PilotedLayout
          session={session}
          interludes={interludes}
          instance={instance}
        />
      );
    if (type === "AUTONOMOUS")
      return (
        <AutonomousLayout
          session={session}
          interludes={interludes}
          instance={instance}
          onNextInterlude={onNextInterlude}
          onPrevInterlude={onPrevInterlude}
          onFinishInterlude={onFinishInterlude}
        />
      );
    return <div>{translate('player.unknownType')}</div>;
  }
}

class PilotedLayout extends React.Component {
  render() {
    const { interludes, instance } = this.props;
    const { currentSequenceInterlude } = instance;
    const interludeToShow = interludes[currentSequenceInterlude];

    return (
      <div className="interlude-wrapper">
        {(!interludeToShow.type ||
          interludeToShow.type === "IMAGE") /** Use constants */ && (
          <img
            src={interludeToShow.downloadURL}
            className="img-responsive"
            alt="Resource"
          />
        )}
        {interludeToShow.type === "VIDEO" /** Use constants */ && (
          <video
            src={interludeToShow.downloadURL}
            className="img-responsive"
            alt="Resource"
            controls={true}
          />
        )}
      </div>
    );
  }
}

class AutonomousLayout extends React.Component {
  isFirstInterlude = () => {
      if (this.props.instance && this.props.instance.currentSequenceInterlude === 0) {
        return true
    } else {
        return false
    }
}

  isLastInterlude = () => {
      if (this.props.instance 
        && this.props.instance.currentSequenceInterlude === (this.props.interludes.length - 1)
        ) {
          return true
      } else {
          return false
      }
  }

  render() {
    const {
      session,
      interludes,
      instance,
      onPrevInterlude,
      onNextInterlude,
      onFinishInterlude
    } = this.props;
      const { currentSequenceInterlude } = instance;
    const interludeToShow = interludes[currentSequenceInterlude];

    return (
      <div className="autonomous-layout row ">
            {interludeToShow &&
                <Fragment>
                    <div className="col-xs-12 col-md-10">
                        <div className="interlude-wrapper">
                            {(!interludeToShow.type ||
                            interludeToShow.type === "IMAGE") /** Use constants */ && (
                            <img
                                src={interludeToShow.downloadURL}
                                className="img-responsive"
                                alt="Resource"
                            />
                            )}
                            {interludeToShow.type === "VIDEO" /** Use constants */ && (
                            <video
                                src={interludeToShow.downloadURL}
                                className="img-responsive"
                                alt="Resource"
                                controls={true}
                            />
                            )}
                        </div>
                        </div>
                        <div className="col-xs-12 col-md-2">
                        <div className="interlude-control-wrapper">
                            <div className="navigation">
                            <div>
                                {!this.isFirstInterlude() && (
                                <Button
                                    text={translate('player.previous')}
                                    icon="chevron-left"
                                    disabled={this.isFirstInterlude()}
                                    onClick={onPrevInterlude}
                                />
                                )}
                            </div>
                                <SequenceInterludePagination
                                session={session}
                                sessionInstance={instance}
                                interludes={interludes}
                            />
                            <div>
                                {this.isLastInterlude() && (
                                <Button
                                    text={translate('start')}
                                    rightIcon="tick"
                                    intent={Intent.SUCCESS}
                                    disabled={!this.isLastInterlude()}
                                    onClick={onFinishInterlude}
                                />
                                )}
                                {!this.isLastInterlude() && (
                                <Button
                                    text={translate('next')}
                                    rightIcon="chevron-right"
                                    disabled={this.isLastInterlude()}
                                    onClick={onNextInterlude}
                                />
                                )}
                            </div>
                            </div>
                        </div>
                    </div>
            </Fragment>
  }
      </div>
    );
  }
}

export default PlayerInterlude;
